import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSelectModule } from '@ng-select/ng-select';
import { RequisitionsPageComponent } from './requisitions-page.component';
import { RequisitionCardModule } from './requisition-card/requisition-card.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.requisitions',
    url: '/requisitions',
    component: RequisitionsPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      requisitionStatesArray: null,
      loginParamsObject: null,
      userParamsObject: null
    }
  }
];

@NgModule({
  declarations: [RequisitionsPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    PaginationModule.forRoot(),
    InfiniteScrollModule,
    NgSelectModule,
    RequisitionCardModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [RequisitionsPageComponent],
  exports: [RequisitionsPageComponent]
})
export class RequisitionsPageModule { }
